module.exports = __webpack_public_path__ + "static/img/9.4b533a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/9.png
// module id = Z6So
// module chunks = 0